import { REDUCERS } from "./reducerConstants";

export function valuesReducer(state, action) {
    let isValid;
    switch (action.type) {
        case REDUCERS.SET_VALUE:
            //handle the emailer
            if (action.isValid !== undefined) {
                isValid = action.isValid;
            } else {
                isValid = action.value !== null;
            }
            return { ...state, [action.name]: { isValid, value: action.value, required: action.required } };
        default:
            return state;
    }
}